import { writable } from 'svelte/store';
import { doc, onSnapshot } from 'firebase/firestore';

export const station = writable(null);

